import { render, staticRenderFns } from "./cdb-rdb.vue?vue&type=template&id=a2530cd4&scoped=true&"
import script from "./cdb-rdb.vue?vue&type=script&lang=js&"
export * from "./cdb-rdb.vue?vue&type=script&lang=js&"
import style0 from "./cdb-rdb.vue?vue&type=style&index=0&id=a2530cd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2530cd4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VAutocomplete,VCol,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2530cd4')) {
      api.createRecord('a2530cd4', component.options)
    } else {
      api.reload('a2530cd4', component.options)
    }
    module.hot.accept("./cdb-rdb.vue?vue&type=template&id=a2530cd4&scoped=true&", function () {
      api.rerender('a2530cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/tiposAtivos/RendaFixa/cdb-rdb.vue"
export default component.exports